import { render } from "./ElementImage.vue?vue&type=template&id=34305982&scoped=true"
import script from "./ElementImage.vue?vue&type=script&lang=js"
export * from "./ElementImage.vue?vue&type=script&lang=js"

import "./ElementImage.vue?vue&type=style&index=0&id=34305982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34305982"]])

export default __exports__